import React from 'react';
import PropTypes from 'prop-types';

import CurrencyFormatter from './CurrencyFormatter.react';

// Refactoring to use forwardRef to properly handle MUI refs
const CurrencyInputFormatter = React.forwardRef<any, any>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <CurrencyFormatter
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
});

CurrencyInputFormatter.propTypes = {
  onChange: PropTypes.func.isRequired,
};

CurrencyInputFormatter.displayName = 'CurrencyInputFormatter';

export default CurrencyInputFormatter;
